import * as API from "../../api"

const HTTP_SERVICE_UNAVAILABLE = 503

// An on-prem SMRT Link server that has not been registered with PacBio answers
// the in-app communications calls with a 503, the same status as other server
// problems. The registration status (404 = not registered) is what tells the
// two apart, and only an administrator can read it; for anyone else this is
// false and the failure is reported as the server error it looks like.
export async function isServerNotRegistered(failedStatus: number | undefined): Promise<boolean> {
    if (failedStatus !== HTTP_SERVICE_UNAVAILABLE || API.isCloudApi()) {
        return false
    }
    try {
        await API.getSystemRegistration()
        return false
    } catch (err) {
        return err instanceof API.ResourceNotFoundError
    }
}
